/**
* @File 
* @Author liubin
* @FilePath src/main/assets/interface/lx.js
*/
const API_APP_CRCL = "/zqyl-app-crcl";
const API_PREFIX_FILE = "/zqyl-file";
const API_PREFIX_APPOFFICE = '/zqyl-appOffice'
// const API_PREFIX_APPOFFICE = '/app/mock/181'
// const API_APP_CRCL = "/app/mock/31";
const API_PREFIX_ABS = '/abs-provider-api';
const API_PREFIX_USER = "/userCenter";
export default  {
    getCompanyNum: API_PREFIX_USER + "/server/queryCompanyCountWithCache",  //企业总数
    shareDataObtain: API_APP_CRCL + '/shareData/obtain',//分享数据(综合接口)
    previewFile: API_PREFIX_FILE + '/file/tokenCheck/previewFile',//文件预览
    taskInfoGetDetail: API_PREFIX_APPOFFICE + '/calendar/taskInfo/getDetail',

    //链信盲盒
    lottery: API_PREFIX_APPOFFICE + '/app/blindbox/lottery', //开启盲盒
    customReal: API_PREFIX_APPOFFICE + '/app/blindbox/customReal', //定制盲盒
    activityDetail: API_PREFIX_APPOFFICE + '/app/blindbox/activity/detail', //活动首页详情
    winRecordList: API_PREFIX_APPOFFICE + '/app/blindbox/winRecord', //我的盲盒列表
    winPerson: API_PREFIX_APPOFFICE + '/app/blindbox/winPerson', //弹幕列表
    realAppointment: API_PREFIX_APPOFFICE + '/app/blindbox/realAppointment', //预约领取
    boxDetail: API_PREFIX_APPOFFICE + '/app/blindbox/boxDetail', //盲盒详情
    realConversion: API_PREFIX_APPOFFICE + '/app/blindbox/realConversion', //预约兑换实物盲盒   
    getFactoringDetail: API_PREFIX_ABS + '/abn/interBank/app/enquiry/infoDetail',//询价分享详情接口
    previewFileNew:  API_PREFIX_FILE + '/file/external/previewFile',// 文件预览

    shareArticleDetail: API_PREFIX_APPOFFICE + '/companyCircle/app/shareArticleDetail', //链信-企业圈，获取分享的文章详情
    articleDetail: API_PREFIX_APPOFFICE + '/companyCircle/app/articleDetail', //链信-企业圈，获取文章详情

    //查询企业签章信息
    querySimpleCompanySign:API_PREFIX_USER + '/auth/company/v2/querySimpleCompanySign',

    //微信内H5跳转app 获取动态签名
    getSignature:API_PREFIX_APPOFFICE + '/app/signature',
    // 链信帮助中心-获取图文详情
    getAppQuestionDetail: `${API_PREFIX_APPOFFICE}/helpCenter/getAppQuestionDetail`
};






